import { formatDate, isDateInRange } from './weekHelper'

export { formatDate, isDateInRange }

export function getMonthRange(dateInput) {
  const date =
    dateInput instanceof Date
      ? new Date(dateInput)
      : new Date(String(dateInput).replace(/-/g, '/'))
  if (Number.isNaN(date.getTime())) {
    return getMonthRange(new Date())
  }
  const startDate = new Date(date.getFullYear(), date.getMonth(), 1)
  const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  return {
    start: formatDate(startDate),
    end: formatDate(endDate),
    startDate,
    endDate
  }
}

export function getLastMonthRange(dateInput) {
  const date =
    dateInput instanceof Date
      ? new Date(dateInput)
      : new Date(String(dateInput).replace(/-/g, '/'))
  if (Number.isNaN(date.getTime())) {
    return getLastMonthRange(new Date())
  }
  const startDate = new Date(date.getFullYear(), date.getMonth() - 1, 1)
  const endDate = new Date(date.getFullYear(), date.getMonth(), 0)
  return {
    start: formatDate(startDate),
    end: formatDate(endDate)
  }
}

export function dateToMonthInput(date) {
  const d = date instanceof Date ? date : new Date(String(date).replace(/-/g, '/'))
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  return `${y}-${m}`
}

export function monthInputToDate(monthValue) {
  if (!monthValue) return new Date()
  const match = String(monthValue).match(/^(\d{4})-(\d{2})$/)
  if (!match) return new Date()
  return new Date(parseInt(match[1], 10), parseInt(match[2], 10) - 1, 1)
}
